import { patients, withSession } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { get } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import SnoozeDropdown from './SnoozeDropdown';

class SnoozeDropdownContainer extends Component {
  static propTypes = {
    mutateUpdatePatient: PropTypes.func,
    patient: PropTypes.object,
    refetchSelectedPatientInfo: PropTypes.func,
  };

  componentWillMount = () => this.handleExpiredSnoozeValue(this.snoozed_until);
  componentWillReceiveProps = ({ patient: { snoozed_until } }) => {
    this.handleExpiredSnoozeValue(snoozed_until);
  };

  get snoozed_until() {
    return get(this.props, 'patient.snoozed_until');
  }

  handleExpiredSnoozeValue = value => {
    if (value && moment(value).isBefore()) {
      this.handleSnoozeChange(null);
    }
  };

  handleSnoozeChange = async newValue =>
    alertOnError(
      this.props.mutateUpdatePatient({
        variables: {
          id: this.props.patient.id,
          modifier: {
            snoozed_until: newValue ? newValue.valueOf() : null,
          },
        },
      }),
    ).then(() => {
      this.props.refetchSelectedPatientInfo();
    });

  render = () => (
    <SnoozeDropdown
      {...this.props}
      onSnoozeChange={this.handleSnoozeChange}
      snoozeValue={this.snoozed_until}
    />
  );
}

const enhance = (Component) => {
  return withSession(
    graphql(patients.mutateUpdatePatient, { name: 'mutateUpdatePatient' })(Component)
  );
};

export default enhance(SnoozeDropdownContainer);
